import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { OnboardingModule } from '@onboarding';
import { NotifyHeightDirective } from '../height.directive';
import { PaymentWrapperComponent } from './payment-wrapper.component';
import { RegisterWrapperComponent } from './register-wrapper.component';

@NgModule({
  declarations: [RegisterWrapperComponent, PaymentWrapperComponent],
  imports: [CommonModule, NotifyHeightDirective, OnboardingModule, IonicModule],
})
export class OnboardingWrappersModule {}
